module.exports = __webpack_public_path__ + "static/media/logo-growin.25f26136.svg";